import { render, staticRenderFns } from "./FactoringRequestView.vue?vue&type=template&id=188c1f46&scoped=true"
import script from "./FactoringRequestView.vue?vue&type=script&lang=js"
export * from "./FactoringRequestView.vue?vue&type=script&lang=js"
import style0 from "./FactoringRequestView.vue?vue&type=style&index=0&id=188c1f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c1f46",
  null
  
)

export default component.exports